import React from 'react';
import PropTypes from 'prop-types';
import { GradientCard } from '../blocks/GradientCard';
import { CompactHeader } from '../blocks/CompactHeader';
import { QuestionPills } from '../blocks/QuestionPills';
import { AiDisclaimer } from '../common/AiDisclaimer';

/**
 * The compact card as a single row: header, pills, then the disclaimer. No summary panel — the
 * answer only appears once the shopper opens the assistant from a pill.
 *
 * The design's content frame is 118.73px tall with a 16px gap, which is exactly the 28px header,
 * the 44px pill row and the 15px disclaimer line with a 16px gap between each.
 */
/** The widest layout, so it carries three API questions before the ask-your-own pill. */
const MAX_QUESTIONS = 3;

export const VariantC = ({ questions, onAskQuestion }) => {
  return (
    <GradientCard variant="variant-c">
      <div
        id="ai-assisted-search-banner-body"
        data-testid="ai-assisted-search-banner-body"
        className={
          'sui-flex sui-grow sui-min-w-0 sui-flex-col sui-gap-4'
          + ' sui-pl-4 sui-pr-6 sui-py-6 lg:sui-pr-8 lg:sui-py-8'
        }
      >
        <CompactHeader />
        <div
          id="ai-assisted-search-banner-suggested-questions"
          data-testid="ai-assisted-search-banner-suggested-questions"
          className="sui-min-w-0"
        >
          <QuestionPills
            questions={questions}
            maxQuestions={MAX_QUESTIONS}
            onAskQuestion={onAskQuestion}
          />
        </div>
        {/* Its own row rather than trailing a summary, so it always reads from the left. */}
        <AiDisclaimer align="start" />
      </div>
    </GradientCard>
  );
};

VariantC.displayName = 'VariantC';

VariantC.propTypes = {
  /** Questions for the pills. `text` is markdown. */
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      position: PropTypes.number.isRequired,
      text: PropTypes.string,
    })
  ),
  /** Called when a question is chosen. */
  onAskQuestion: PropTypes.func,
};
